import { AlertDialogFooter } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useAudio } from "@/contexts/AudioContext"
import { useOrder } from "@/contexts/OrderContext"
import { KeyboardIcon, TableIcon } from "lucide-react"
import React from "react"

const clinicalExamMembersLabel = {
    "elbows": "Les coudes",
    "shoulders": "Les épaules",
    "upper-limb-deep-tendon-reflexes": "Les réflexes ostéotendineux des membres supérieurs",
    "upper-limbs-strengths": "Les forces au niveau des membres supérieurs",
    "upper-limbs-measurements-muscle-masses": "Les mesures des masses musculaires des membres supérieurs",
    "wrists": "Les poignets",
    "knees": "Les genoux",
    "hips": "Les hanches",
    "lower-limbs-deep-tendon-reflexes": "Les réflexes ostéotendineux des membres inférieurs",
    "lower-limbs-strengths": "Les forces au niveau des membres inférieurs",
    "lower-limbs-measurements-muscle-masses": "Les mesures des masses musculaires des membres inférieurs",
    "ankles": "Les chevilles",
    "cervical-spine": "La colonne/rachis cervicale",
    "lumbar-spine": "La colonne lombaire",
    "hands": "Les mains",
    "radicular": "Les manoeuvres radiculaires",
}


export default function ExamTablesDialog({ setOpen, editor }) {
    const { examTables } = useOrder()

    return <Dialog open={!!editor} onOpenChange={setOpen}>
        <DialogContent>
            <DialogHeader>
                <DialogTitle className="flex items-center gap-2"><TableIcon /> Tableaux d'examen</DialogTitle>
            </DialogHeader>

            <Command className="rounded-lg border shadow-md md:min-w-[450px]">
                <CommandInput placeholder="Rechercher..." />
                <CommandList>
                    {examTables && Object.keys(examTables).map((key) => (
                        <CommandItem
                            key={key}
                            value={clinicalExamMembersLabel[key]} // Search will now work on this value
                            data-key={key} // Store the actual key for selection
                            onSelect={() => {
                                editor.chain().focus().insertContent(examTables[key]).run();
                                setOpen(null);
                            }}
                        >
                            <span>{clinicalExamMembersLabel[key]}</span>
                        </CommandItem>
                    ))}
                </CommandList>
            </Command>
        </DialogContent>
    </Dialog>
}